import React from "react";
import "./../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../../Styles/app.css";
import "./Styles/style.css";
import "./Styles/theme-responsive.css";
import { connect } from "react-redux";
import {
  RegisterFooter,
  RegisterHeader,
  RegisterWizard,
  SubmitButton,
} from "../../CommonComponents";
import "../../../../node_modules/font-awesome/css/font-awesome.min.css";
import verifyEmailImage from "../../assets/registerImages/verify-email.svg";
import verifiedEmailImage from "../../assets/registerImages/email-verified.svg";
import { createLoadingSelector } from "../../../common/reducers/selectors";
import RingLoader from "react-spinners/ClipLoader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation } from "react-i18next";

import {
  verifiedUserEmail,
  verifiedUserEmailClear,
  reSendEmailUser,
  reSendEmailClear,
  saveRegistrationInfo,
} from "../../../common/actions/userAccount";
toast.configure();
const loadingSelector = createLoadingSelector([
  "verified_email",
  "re_send_email",
]);

class ConfirmEmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVerified: false,
    };
  }

  verifiedEmail = () => {
    this.setState({ isVerified: true });
  };

  submitForm = () => {
    this.props.history.push("/registerPhone");
  };
  back = () => {
    this.props.history.goBack();
  };

  advancePage = () => {
    const { doVerifiedUserEmail, registeredToken } = this.props;

    let { registeredEmail } = this.props;
    if(registeredEmail.includes(".staging")){
		registeredEmail = registeredEmail.replace(".staging", "");
	}else if(registeredEmail.includes(".develop")){
		registeredEmail = registeredEmail.replace(".develop", "");
	}else if(registeredEmail.includes(".localhost")){
		registeredEmail = registeredEmail.replace(".localhost", "");
	}
	

    doVerifiedUserEmail({
      Email: registeredEmail,
      RegistrationTokenID: registeredToken,
    });
  };

  resendEmail = () => {
    const { doReSendEmailUser } = this.props;
    let { registeredEmail } = this.props;
    if(registeredEmail.includes(".staging")){
		registeredEmail = registeredEmail.replace(".staging", "");
	}else if(registeredEmail.includes(".develop")){
		registeredEmail = registeredEmail.replace(".develop", "");
	}else if(registeredEmail.includes(".localhost")){
		registeredEmail = registeredEmail.replace(".localhost", "");
	}

    doReSendEmailUser({ Email: registeredEmail });
  };

  componentDidUpdate() {
    const { isVerified } = this.state;
    const {
      verifiedEmailResponse,
      doVerifiedUserEmailClear,
      error,
      reSendEmailResponse,
      doReSendEmailClear,
      doSaveRegistrationInfo,
      registeredEmail,
    } = this.props;

    
    if (verifiedEmailResponse) {
      if (verifiedEmailResponse.Success === true) {
        doVerifiedUserEmailClear();
        this.setState({ isVerified: true });
        doSaveRegistrationInfo({
          verifiedEmail: registeredEmail,
        });
      } else if (
        isVerified === false &&
        verifiedEmailResponse.Success === false
      ) {
        doVerifiedUserEmailClear();
        toast.error(`${this.props.t("confirmEmailScr-check-mailbox")}`, {
          autoClose: 2000,
        });
      }
    } else if (error) {
      toast.error(error.Message || error.message, { autoClose: 2000 });
    } else if (reSendEmailResponse) {
      toast.info(reSendEmailResponse.Message, { autoClose: 2000 });
      doReSendEmailClear();
    }
  }

  render() {
    const { isVerified } = this.state;
    const { registeredEmail, isFetching } = this.props;

    return (
      <section className="registration">
        <div className="wrapper">
          <div className="landing-wrapper">
            <div className="row h-100vh nomargin-row">
              <RegisterHeader />
              <div className="col-sm-12 col-md-5 col-lg-5 col-xl-4 sidebar-col">
                <div className="sidebar-wrapper">
                  <form className="form-style1">
                    <RegisterWizard webPage={this.props.location.pathname} />
                    {isVerified === true ? (
                      <>
                        {" "}
                        <figure className="mb-40">
                          <img
                            src={verifiedEmailImage}
                            alt="PikMyKid"
                            title="PikMyKid"
                          />
                        </figure>
                        <div className="title-sect mb-40">
                          <h3 className="title-3">
                            {this.props.t("regConEmailScr-EmailVerify")}
                          </h3>
                          <p className="helptext">
                            {this.props.t("regConEmailScr-regProcess")}
                          </p>
                        </div>
                        <div className="form-group">
                          <SubmitButton
                            nextAction={() => {
                              this.submitForm();
                            }}
                          />
                        </div>{" "}
                      </>
                    ) : (
                      <>
                        {" "}
                        <figure className="mb-40">
                          <img
                            src={verifyEmailImage}
                            alt="PikMyKid"
                            title="PikMyKid"
                          />
                        </figure>
                        <div className="title-sect mb-40">
                          <h3 className="title-3">
                            {this.props.t("regConEmailScr-verify-emailLabel")}
                          </h3>
                          <p className="helptext">
                            {this.props.t("regConEmailScr-sentEmail")}{" "}
                            <a
                              className="orange-text"
                              href={`mailto:${registeredEmail}`}
                            >
                              {registeredEmail}
                            </a>{" "}
                            {this.props.t("regConEmailScr-EmailLink")}{" "}
                            <a
                              onClick={this.resendEmail}
                              className="needhelp-label"
                            >
                              {this.props.t("regConEmailScr-clickhere")}
                            </a>{" "}
                            {this.props.t("regConEmailScr-resend-link")}
                          </p>
                        </div>
                        <div className="form-group mb-40">
                          <a
                            onClick={this.back}
                            className="needhelp-label"
                          >
                            {this.props.t("regConEmailScr-changeEmail")}
                          </a>
                        </div>
                        <div className="form-group">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.advancePage}
                          >
                            {" "}
                            {isFetching ? (
                              <i className="fas fa-sync-alt fa-spin"></i>
                            ) : null}{" "}
                            &nbsp; {this.props.t("regCardScr-verifyEmail")}
                          </button>
                        </div>
                      </>
                    )}
                  </form>

                  <RegisterFooter />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    registeredToken: state.userAccount.registeredToken,
    registeredEmail: state.userAccount.registeredEmail,
    verifiedEmailResponse: state.userAccount.verifiedEmailResponse,
    reSendEmailResponse: state.userAccount.reSendEmailResponse,
    isFetching: loadingSelector(state),
    error: state.userAccount.error,
    emailResendError: state.userAccount.emailResendError,
    verifiedEmail: state.userAccount.verifiedEmail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    doVerifiedUserEmail: (data) => dispatch(verifiedUserEmail(data)),
    doVerifiedUserEmailClear: () => dispatch(verifiedUserEmailClear()),
    doReSendEmailUser: (data) => dispatch(reSendEmailUser(data)),
    doReSendEmailClear: () => dispatch(reSendEmailClear()),
    doSaveRegistrationInfo: (data) => dispatch(saveRegistrationInfo(data)),
  };
}
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail)
);
